export const SALES_APP_VERSION_PARAM_KEY = 'sales_app_version';
export const DESKTOP_APP_LAST_VERSION_PARAM_KEY = 'desktop_app_last_version';
export const LUCKEY_DEMO_WEEKLY_CLEANUP_WHITELIST_PARAM_KEY = 'luckey_demo_weekly_cleanup_whitelist';
export const WALLET_DISABLE_EXCLUSION_IDS_PARAM_KEY = 'wallet_disable_exclusion_ids';
export const DEMO_WHITELIST_DOMAIN_PREFIX = 'api-';
export const DEMO_WHITELIST_DOMAIN_SUFFIX = '.jago.cloud';
